<template>
  <div class="container-fluid">
    <loading :active.sync="isLoading" loader="dots"></loading>

    <div class="card search-card">
      <div class="card-body">
        <div class="form-row">
          <div class="col-sm-3 col-md">
            <div class="form-group">
              <label for="">流程名稱</label>
              <input
                type="text"
                class="form-control"
                placeholder="請輸入關鍵字"
                v-model.trim="search.Name"
              />
            </div>
          </div>

          <div class="col-sm-3 col-md">
            <div class="form-group">
              <label for="">是否啟用</label>
              <el-select
                style="display: block"
                v-model="search.IsEnabled"
                placeholder="請選擇"
                clearable
              >
                <el-option label="是" :value="true"> </el-option>
                <el-option label="否" :value="false"> </el-option>
              </el-select>
            </div>
          </div>

          <div class="col-sm-3 col-md-4">
            <button
              type="button"
              class="btn btn-primary"
              style="margin-top: 30px; margin-right: 5px"
              @click="getFlowSource"
            >
              {{ i18n("BUTTON.SEARCH") }}
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              style="margin-top: 30px; margin-right: 5px"
              @click="search = {}"
            >
              清除
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="function-card">
      <button
        type="button"
        class="btn btn-primary mr-2"
        @click="dialogVisible = true"
      >
        階段資料維護
      </button>
      <button
        type="button"
        class="btn btn-primary"
        @click="openSettingModal({ action: 'add' })"
      >
        新增流程
      </button>
    </div>

    <div class="yahome-table-wrap">
      <el-table :data="rows" style="width: 100%">
        <el-table-column type="expand">
          <template slot-scope="props">
            <div class="d-row header">
              <div>階段名稱</div>
              <div>建議時間</div>
              <div>類型</div>
              <div>主管類型</div>
            </div>

            <div
              class="d-row"
              v-for="(element, index) in props.row.Stages"
              :key="index"
            >
              <div>
                {{ element.Name }}
              </div>
              <div>
                {{ element.SugMinutes }}
              </div>
              <div>
                {{ element.TypeString }}
              </div>
              <div>
                {{ element.InterviewUserType }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="面談流程名稱" prop="Name"> </el-table-column>
        <el-table-column label="啟用">
          <template slot-scope="props">
            <svg
              v-if="props.row.IsEnabled"
              width="23"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path
                d="M 400.6 173.4 c 12.5 12.5 12.5 32.8 0 45.3 l -188 188 c -12.5 12.5 -32.8 12.5 -45.3 0 l -100 -100 c -12.5 -12.5 -12.5 -32.8 0 -45.3 s 32.8 -12.5 45.3 0 L 192 338.7 L 355 173 c 12.5 -12.5 32.8 -12.5 45.3 0 z"
              />
            </svg>

            <svg
              v-if="!props.row.IsEnabled"
              width="15"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 320 512"
            >
              <path
                d="M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z"
              />
            </svg>
          </template>
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="props">
            <button
              type="button"
              class="btn btn-danger btn-sm mr-2"
              @click="showDeleteFlowDialog(props.row)"
            >
              刪除
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="openSettingModal({ action: 'edit', data: props.row })"
            >
              維護
            </button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 新增 & 編輯 Modal -->
    <div
      class="modal fade"
      id="settingModal"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <ValidationObserver ref="settingModal" class="modal-content">
          <form @reset.prevent="reset">
            <div class="modal-header">
              <span v-if="isAddSetting">新增流程</span>
              <span v-else>編輯流程</span>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <label for="">
                    <span class="mark">*</span>
                    流程名稱
                    <span class="text-danger">(不可重複)</span>
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    v-model.trim="settingModal.Name"
                  />

                  <span class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="text-center">已選取項目</div>

                  <draggable
                    :list="settingModal.Stages"
                    group="stageList"
                    class="drog-list draggableSelect"
                    @add="onAdd"
                    :move="handleMove"
                  >
                    <div
                      v-for="(element, index) in settingModal.Stages"
                      :key="index"
                      class="d-item"
                    >
                      {{ element.Name }}
                      <template v-if="element.InterviewUserType">
                        <br />({{ element.InterviewUserType }})
                      </template>
                    </div>
                  </draggable>
                </div>
                <div class="col-md-6">
                  <div class="text-center">未選取項目</div>
                  <draggable
                    :list="unselectStageList"
                    group="stageList"
                    class="drog-list undraggableSelect"
                  >
                    <div
                      v-for="(element, index) in unselectStageList"
                      :key="index"
                      class="d-item"
                    >
                      {{ element.Name }}
                      <template v-if="element.InterviewUserType">
                        <br />({{ element.InterviewUserType }})
                      </template>
                    </div>
                  </draggable>
                </div>
              </div>

              <div class="form-group">
                <label for=""> 狀態 </label>
                <el-switch
                  style="display: block"
                  v-model="settingModal.IsEnabled"
                  active-color="#409eff"
                  inactive-color="#ccc"
                  active-text="啟用"
                  inactive-text="未啟用"
                >
                </el-switch>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="reset"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                {{ i18n("Buttons.Cancel") }}
              </button>
              <button
                type="button"
                class="btn btn-success"
                @click="saveFlowSource"
              >
                {{ i18n("Buttons.Save") }}
              </button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <!-- stage modal -->
    <el-dialog
      title="階段設定"
      :visible.sync="dialogVisible"
      width="680px"
      :close-on-click-modal="false"
    >
      <div class="text-right mb-2">
        <el-button type="primary" size="mini" @click="showStageDialog()"
          >新增</el-button
        >
      </div>
      <el-table :data="stageList" style="width: 100%">
        <el-table-column prop="Name" label="階段名稱"> </el-table-column>
        <el-table-column prop="type" label="類型">
          <template slot-scope="props">
            <span v-if="props.row.Type === 1">考試</span>
            <span v-if="props.row.Type === 2">面試</span>
            <span v-if="props.row.Type === 3">問卷填寫</span>
          </template>
        </el-table-column>
        <el-table-column prop="SugMinutes" label="建議時間"> </el-table-column>
        <el-table-column prop="InterviewUserType" label="主管類型">
        </el-table-column>
        <el-table-column width="150">
          <template slot-scope="props">
            <el-button
              type="danger"
              @click="showDeleteStageDialog(props.row)"
              size="mini"
              >刪除</el-button
            >
            <el-button
              type="primary"
              @click="showStageDialog(props.row)"
              size="mini"
              >維護</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">關閉</el-button>
      </span>
    </el-dialog>

    <!-- flow delete modal -->
    <el-dialog
      title="刪除"
      :visible.sync="deleteFlowDialogVisible"
      width="480px"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="form-group">
        是否確定刪除<span style="color: #ff0000; font-weight: bold">{{
          currentItem.Name
        }}</span
        >？
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteFlowDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="deleteFlow()">確定</el-button>
      </span>
    </el-dialog>

    <!-- stage delete modal -->
    <el-dialog
      title="刪除"
      :visible.sync="deleteStageDialogVisible"
      width="480px"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="form-group">
        是否確定刪除<span style="color: #ff0000; font-weight: bold">{{
          currentItem.Name
        }}</span
        >？
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteStageDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="deleteStage()">確定</el-button>
      </span>
    </el-dialog>

    <!-- 新增階段 -->
    <el-dialog
      title="階段"
      destroy-on-close
      :visible.sync="stageDialogVisible"
      width="680px"
      append-to-body
      :close-on-click-modal="false"
    >
      <ValidationObserver ref="settingModal" v-slot="{ handleSubmit }">
        <form>
          <div class="form-group">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <label for="">
                <span class="mark">*</span>
                階段名稱
                <span class="text-danger">(不可重複)</span>
              </label>
              <input
                type="text"
                class="form-control"
                v-model.trim="stageModal.Name"
              />

              <span class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
          <div class="form-group">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <label for=""> <span class="mark">*</span>類型 </label>
              <el-select
                v-model="stageModal.Type"
                placeholder="請選擇"
                style="width: 100%"
                :disabled="stageModal.Guid"
              >
                <el-option
                  v-for="option in stageTypeList"
                  :key="option.Value"
                  :label="option.Text"
                  :value="option.Value"
                >
                </el-option>
              </el-select>
              <span class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
          <div class="form-group">
            <ValidationProvider
              name="建議時間"
              rules="required"
              v-slot="{ errors }"
            >
              <label for="">
                <span class="mark">*</span>
                建議時間
              </label>
              <input
                type="number"
                max="120"
                min="1"
                class="form-control"
                v-model.trim="stageModal.SugMinutes"
              />

              <span class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
          <div class="form-group" v-if="stageModal.Type === 2">
            <ValidationProvider
              name="主管類型"
              rules="required"
              v-slot="{ errors }"
            >
              <label for="">
                <span class="mark">*</span>
                主管類型
              </label>
              <el-select
                v-model="stageModal.InterviewUserType"
                placeholder="請選擇"
                style="width: 100%"
                :disabled="stageModal.Guid"
              >
                <el-option label="單位面試主管" value="單位面試主管">
                </el-option>
                <el-option label="HR面試人員" value="HR面試人員"> </el-option>
              </el-select>

              <span class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </form>

        <span class="dialog-footer">
          <el-button @click="stageDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleSubmit(saveStage)"
            >儲存</el-button
          >
        </span>
      </ValidationObserver>
    </el-dialog>
  </div>
</template>

<script>
/* global $ */
import draggable from "vuedraggable";
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  name: "RoomScheduleSetting",

  components: {
    draggable,
  },
  data() {
    return {
      deleteDialogVisible: false,
      isAddDetail: false,
      // detailModal: {},
      fetchSuggestionsList: [
        { value: "HR面試", name: "HR面試" },
        { value: "主管面試", name: "主管面試" },
        { value: "問卷填寫", name: "問卷填寫" },
      ],
      search: {
        IsEnabled: true,
      },

      dialogVisible: false,
      stageList: [],
      stageTypeList: [],
      stageModal: {},
      stageDialogVisible: false,
      deleteStageDialogVisible: false,
      currentItem: {},

      unselectStageList: [],

      rows: [],
      isAddSetting: false,
      settingModal: {},
      deleteFlowDialogVisible: false,
    };
  },

  methods: {
    getFlowSource() {
      const vm = this;
      let params = { ...vm.search };
      vm.$api.InterviewSch.getFlowSource(params)
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.rows = response.data.Data;
          }
          vm.$loadingStore.closeLoading();
        })
        .catch((error) => {
          vm.$loadingStore.closeLoading();
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    saveFlowSource() {
      const vm = this;

      vm.settingModal.Stages = vm.settingModal.Stages.map((item, index) => {
        return {
          ...item,
          Seq: index + 1,
        };
      });

      if (vm.isAddSetting) {
        vm.$api.InterviewSch.createFlowSource(vm.settingModal)
          .then((response) => {
            if (response.data.ErrorMessage) {
              vm.$notify({
                message: response.data.ErrorMessage,
                type: "error",
              });
            } else {
              vm.getFlowSource();
              $("#settingModal").modal("hide");
              vm.$notify({
                message: response.data.Data,
                type: "success",
              });
            }
            vm.$loadingStore.closeLoading();
          })
          .catch((error) => {
            vm.$loadingStore.closeLoading();
            this.$notify({
              title: "錯誤",
              message: error.response.data.ErrorMessage,
              type: "error",
            });
          });
      } else {
        vm.$api.InterviewSch.editFlowSource(vm.settingModal)
          .then((response) => {
            if (response.data.ErrorMessage) {
              this.$notify({
                message: response.data.ErrorMessage,
                type: "error",
              });
            } else {
              vm.getFlowSource();
              $("#settingModal").modal("hide");
              vm.$notify({
                message: response.data.Data,
                type: "success",
              });
            }
            vm.$loadingStore.closeLoading();
          })
          .catch((error) => {
            vm.$loadingStore.closeLoading();
            this.$notify({
              title: "錯誤",
              message: error.response.data.ErrorMessage,
              type: "error",
            });
          });
      }
    },

    showDeleteFlowDialog(row) {
      const vm = this;
      vm.currentItem = { ...row };
      vm.deleteFlowDialogVisible = true;
    },

    deleteFlow() {
      const vm = this;
      vm.$api.InterviewSch.deleteFlowSource(vm.currentItem.Guid)
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.getFlowSource();
            vm.deleteFlowDialogVisible = false;
            vm.$notify({
              message: response.data.Data,
              type: "success",
            });
          }
          vm.$loadingStore.closeLoading();
        })
        .catch((error) => {
          vm.$loadingStore.closeLoading();
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    getStage() {
      const vm = this;
      vm.$api.InterviewSch.getStage()
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.stageList = response.data.Data;
          }
          vm.$loadingStore.closeLoading();
        })
        .catch((error) => {
          vm.$loadingStore.closeLoading();
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    getStageType() {
      const vm = this;
      vm.$api.InterviewSch.getStageType()
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.stageTypeList = response.data.Data;
          }
          vm.$loadingStore.closeLoading();
        })
        .catch((error) => {
          vm.$loadingStore.closeLoading();
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    showDeleteStageDialog(row) {
      const vm = this;
      vm.currentItem = { ...row };
      vm.deleteStageDialogVisible = true;
    },

    showStageDialog(row) {
      const vm = this;
      if (row) {
        vm.stageModal = { ...row };
      } else {
        vm.stageModal = {};
      }
      vm.stageDialogVisible = true;
    },

    saveStage() {
      const vm = this;
      if (vm.stageModal.Guid) {
        vm.$api.InterviewSch.editStage(vm.stageModal)
          .then((response) => {
            if (response.data.ErrorMessage) {
              this.$notify({
                message: response.data.ErrorMessage,
                type: "error",
              });
            } else {
              vm.getStage();
              vm.stageDialogVisible = false;
              vm.$notify({
                message: response.data.Data,
                type: "success",
              });
            }
            vm.$loadingStore.closeLoading();
          })
          .catch((error) => {
            vm.$loadingStore.closeLoading();
            this.$notify({
              title: "錯誤",
              message: error.response.data.ErrorMessage,
              type: "error",
            });
          });
      } else {
        vm.$api.InterviewSch.createStage(vm.stageModal)
          .then((response) => {
            if (response.data.ErrorMessage) {
              this.$notify({
                message: response.data.ErrorMessage,
                type: "error",
              });
            } else {
              vm.getStage();
              vm.stageDialogVisible = false;
              vm.$notify({
                message: response.data.Data,
                type: "success",
              });
            }
            vm.$loadingStore.closeLoading();
          })
          .catch((error) => {
            vm.$loadingStore.closeLoading();
            this.$notify({
              title: "錯誤",
              message: error.response.data.ErrorMessage,
              type: "error",
            });
          });
      }
    },

    deleteStage() {
      const vm = this;
      vm.$api.InterviewSch.deleteStage(vm.currentItem.Guid)
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.getStage();
            vm.deleteStageDialogVisible = false;
            vm.$notify({
              message: response.data.Data,
              type: "success",
            });
          }
          vm.$loadingStore.closeLoading();
        })
        .catch((error) => {
          vm.$loadingStore.closeLoading();
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    openSettingModal({ action, data }) {
      switch (action) {
        case "add":
          this.settingModal = {
            Stages: [],
            IsEnabled: true,
          };
          this.isAddSetting = true;
          break;
        case "edit":
          this.settingModal = JSON.parse(JSON.stringify(data));
          this.isAddSetting = false;
          break;
      }

      let flatArray = this.settingModal.Stages.map((item) => item.StageGuid);

      let filterArray = this.stageList.filter((e) => {
        return flatArray.indexOf(e.Guid) === -1;
      });

      this.unselectStageList = filterArray.map((item) => {
        return {
          ...item,
          StageGuid: item.Guid,
        };
      });

      $("#settingModal").modal("show");
    },

    // vue-draggable 移動 method
    handleMove(e) {
      const disableSortStageName = "滿意度問卷";
      if (
        e.draggedContext.element.Name === disableSortStageName &&
        e.from.className === e.to.className &&
        e.to.className === "drog-list draggableSelect"
      ) {
        return false;
      }
    },

    // vue-draggable 新增項目 method
    onAdd() {
      const nowStagesCount = this.settingModal.Stages.length;
      const disableSortStageName = "滿意度問卷";
      let isUpdateArray = false;
      let newAry = Array.from(this.settingModal.Stages);

      for (let i = 0; i < newAry.length; i++) {
        const item = newAry[i];
        if (item.Name === disableSortStageName && i !== nowStagesCount) {
          newAry.splice(i, 1); // 移除該項目
          newAry.push(item); // 加到陣列尾端
          isUpdateArray = true;
          break; // 中斷迴圈
        }
      }

      if (isUpdateArray) {
        this.settingModal.Stages = newAry;
      }
    },

    querySearch(queryString, cb) {
      let restaurants = this.fetchSuggestionsList;
      let results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 調用 callback 返回建議列表的數據
      cb(results);
    },

    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },

    openStageModal() {
      $("#stageModal").modal("show");
    },

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  computed: {
    ...mapGetters(["lang"]),
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  filters: {
    moment: function (date) {
      if (date === null) {
        return null;
      } else {
        return moment(date).format("YYYY-MM-DD HH:mm");
      }
    },
  },

  created() {
    this.getStage();
    this.getStageType();
    this.getFlowSource();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>

<style lang="scss" scoped>
.drog-list {
  min-height: 300px;
  background-color: #fafafa;
  padding: 5px;
  border-radius: 5px;
  height: 100%;
  .d-item {
    border-radius: 5px;
    text-align: center;
    padding: 3px 10px;
    margin-bottom: 5px;
    background-color: #dcebff;
  }
}
.d-row {
  display: flex;
  border-bottom: 1px solid #f1f1f1;

  &:last-child {
    border-bottom: none;
  }

  &:nth-child(even) {
    background-color: #f1f1f1;
  }

  &.header {
    background-color: #f1f1f1;
  }

  div {
    padding: 5px;
    &:first-child {
      flex: 1;
    }

    &:nth-child(2),
    &:nth-child(3),
    &:nth-child(4) {
      width: 120px;
      text-align: center;
    }
  }
}
</style>
